import { AspectRatio, Flex, Image, motion } from '@hover/blueprint';
import type { FlexProps } from '@hover/blueprint';
import { AnimatePresence } from 'framer-motion';
import React from 'react';

import {
  BottomText,
  type BottomTextProps,
} from 'src/modules/homeownerApp/components/BottomText/BottomText';

import { useProTranslate } from '../../hooks';

export type LandingPageSpaceType =
  | 'bathroom'
  | 'exterior'
  | 'kitchen'
  | 'living_room';

export type LandingPageStyle =
  | 'Coastal'
  | 'Contemporary'
  | 'Farmhouse'
  | 'Mid-Century Modern'
  | 'Traditional'
  | 'Original';

const MotionImage = motion(Image);

interface ExampleCardProps extends FlexProps {
  spaceType: LandingPageSpaceType;
  styleName: LandingPageStyle;
  isBeforeSelected: boolean;
  maxImageHeight?: string;
  bottomTextProps?: BottomTextProps;
  ratio?: number;
  exampleNumber?: number;
  imgUrl: string;
}

const SampleImage = ({
  bottomTextProps,
  spaceType,
  styleName,
  isBeforeSelected = true,
  maxImageHeight,
  ratio,
  imgUrl,
  ...rest
}: ExampleCardProps) => {
  const t = useProTranslate();

  const imageDescription = `${
    isBeforeSelected ? '' : 'Before: '
  }${styleName}, ${spaceType}`;

  const primaryText = t(`spaceTypes.${spaceType}`);

  return (
    <Flex alignItems="flex-start" flexDirection="column" width="100%" {...rest}>
      <AspectRatio
        height={ratio ? undefined : '100%'}
        maxHeight={maxImageHeight}
        ratio={ratio}
        width="100%"
      >
        <AnimatePresence initial={false} mode="popLayout">
          <MotionImage
            alt={imageDescription}
            animate={{ opacity: 1 }}
            borderRadius={350}
            exit={{ opacity: 0 }}
            initial={{ opacity: 0 }}
            key={imageDescription}
            src={imgUrl}
          />
        </AnimatePresence>
      </AspectRatio>
      <BottomText
        ml={200}
        mt={400}
        primaryText={primaryText}
        secondaryText={isBeforeSelected ? t('before') : styleName}
        {...bottomTextProps}
      />
    </Flex>
  );
};

export { SampleImage };
